import { render, staticRenderFns } from "./StatementInstitution.vue?vue&type=template&id=047505ea"
import script from "./StatementInstitution.vue?vue&type=script&lang=js"
export * from "./StatementInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports